export default function Testimonial() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
        <div className="lg:w-[60%]">
          <span className="inline-flex items-center gap-2 text-xs font-semibold text-accent-700 uppercase tracking-wider">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            User Reviews
          </span>

          <blockquote className="mt-6 text-2xl md:text-4xl lg:text-5xl font-heading italic text-foreground-900 leading-tight">
            &ldquo;This spreadsheet system completely transformed how I track orders and calculate profits.&rdquo;
          </blockquote>

          <div className="mt-6 flex items-center gap-3">
            <span className="text-sm md:text-base font-bold text-foreground-900">Alex R.</span>
            <span className="w-4 h-4 flex items-center justify-center text-accent-500">
              <i className="ri-verified-badge-fill text-lg"></i>
            </span>
            <span className="text-xs md:text-sm text-foreground-500">Verified Reseller</span>
          </div>
        </div>

        <div className="lg:w-[40%]">
          <div className="w-full aspect-[3/4] rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20modern%20fulfillment%20workspace%20with%20organized%20clothing%20items%20on%20garment%20rack%2C%20packing%20station%20with%20boxes%20and%20laptop%20in%20background%2C%20warm%20ambient%20lighting%2C%20clean%20organized%20warehouse%20aesthetic%2C%20soft%20focus%20depth%20of%20field%2C%20editorial%20business%20photography%2C%20productive%20atmosphere&width=600&height=800&seq=testimonial-pack-v2&orientation=portrait"
              alt="Verified ACBuySpreadsheet user testimonial"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}